angular.module('sharecrf.login-info', [
    'event',
    'sharecrf-auth',
]);